// Mirrors Go rules in binding.go, repo_branch_form.go, branches.go. Server stays authoritative.

export const BRANCH_NAME_MAX_LENGTH = 100;

// Same character class as GitRefNamePatternInvalid.
const invalidCharPattern = /[\0-\x1f\x7f \\~^:?*[%]/;

const reservedBranchNames = ["devicelink", "default_branch"];

// Git ref format rules beyond the character class.
function hasInvalidFormat(name) {
  if (
    name.startsWith("/") ||
    name.endsWith("/") ||
    name.endsWith(".") ||
    name.includes("..") ||
    name.includes("//") ||
    name.includes("@{") ||
    name === "@"
  ) {
    return true;
  }

  return name
    .split("/")
    .some((part) => part.endsWith(".lock") || part.startsWith("."));
}

const invalid = (message) => ({ valid: false, message: message || "" });

// Names the offending character so the message can point straight at it.
function describeChar(char, messages) {
  if (char === " ") return messages.charSpace || "spaces";
  if (char <= "\x1f" || char === "\x7f") {
    return messages.charControl || "control characters";
  }
  return `"${char}"`;
}

// Returns {valid, message}; messages holds translated copy per failure class.
export function validateBranchName(name, messages = {}) {
  // Count code points, not UTF-16 units, to match Go's utf8.RuneCountInString.
  if (Array.from(name).length > BRANCH_NAME_MAX_LENGTH) {
    return invalid(messages.tooLong);
  }

  const badChar = invalidCharPattern.exec(name);
  if (badChar) {
    return invalid(
      (messages.invalidChars || "").replace(
        "%s",
        () => describeChar(badChar[0], messages),
      ),
    );
  }

  if (hasInvalidFormat(name)) {
    return invalid(messages.invalidFormat);
  }

  if (reservedBranchNames.includes(name)) {
    return invalid(messages.reserved);
  }

  return { valid: true, message: "" };
}

// Publishes result via setCustomValidity so the browser owns submittability.
export function applyBranchNameValidity(inputEl, messages = {}) {
  const result = validateBranchName(inputEl.value, messages);
  inputEl.setCustomValidity(result.valid ? "" : result.message);
  return result;
}

// Reads translated messages from the form's data attributes.
export function getBranchNameMessages(formEl) {
  if (!formEl) return {};
  return {
    tooLong: formEl.getAttribute("data-name-too-long-message") || "",
    invalidChars: formEl.getAttribute("data-name-invalid-chars-message") || "",
    invalidFormat: formEl.getAttribute("data-name-invalid-format-message") || "",
    reserved: formEl.getAttribute("data-name-reserved-message") || "",
    charSpace: formEl.getAttribute("data-name-char-space-message") || "",
    charControl: formEl.getAttribute("data-name-char-control-message") || "",
  };
}
